// extracted by mini-css-extract-plugin
export default {"zoomModal":"Hba-z"};